<template>
	<el-input
		class="textarea-item"
		type="textarea"
		:rows="rows"
		v-model="_value"
		:style="_style"
		v-bind="$attrs"
		:disabled="disabled"
		@blur="blur"
	></el-input>
</template>

<script>
export default {
	name: "textarea-item",
	props: {
		value: {
			type: String | Number
		},
		width: {
			type: String,
			default: "280px"
		},
		rows: {
			type: Number,
			default: 3
		},
		styleSheet: {
			type: Object,
			default: function() {
				return {};
			}
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {};
	},
	computed: {
		_value: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		_style() {
			return Object.assign(
				{},
				{
					width: this.width,
					height: this.height,
					"line-height": this.height
				},
				this.styleSheet
			);
		}
	},
	methods: {
		change(val) {
			this._value = val;
		},
		blur() {
			this.$emit("blur");
		}
	}
};
</script>
<style lang='scss' scoped>
::v-deep.textarea-item.el-input {
	// height: 32px;
	width: 280px;
	.el-input__inner {
		width: 100%;
		height: 100%;
		border: 1px solid rgba(0, 0, 0, 0.12);
		border-radius: 20px;
	}
}
</style>
